<template>
  <div>
    <h4 class="text-center">Authorize</h4>

    <p class="mt-3 text-center text-muted">
      Amio needs some permission for your Facebook account in order to start with messaging. We ask you for minimum
      possible set of permissions to let Amio works.
    </p>
    <div class="d-flex justify-content-center mt-3">
      <a href="#" role="button"
         class="btn btn-primary px-5"
         @click="promiseLoginFbUser = loginFacebookUser()"
         v-busy-button="promiseLoginFbUser"
      >
        Authorize
      </a>
    </div>

  </div>
</template>

<script>
  import facebookService from '@/services/facebook/facebook.service'

  export default {
    store: {
      loginStatus: 'administration.channelDetail.facebook.loginStatus'
    },

    data() {
      return {
        promiseLoginFbUser: null
      }
    },

    methods: {
      loginFacebookUser() {
        return facebookService
          .login()
          .then(loginStatus => {
            this.loginStatus = loginStatus
            this.promiseLoginFbUser = null
          })
      }
    }
  }
</script>
